exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_wks-ext.js
// module id = ../node_modules/core-js/modules/_wks-ext.js
// module chunks = 0